/** @jsxImportSource @emotion/react */
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ApprovalAppd } from 'models/approves/ReferenceOpinion';
import { SubTitleGroup, SubTitleLayout } from 'components/layouts/ContentLayout';
import CustomGrid from 'components/grids/CustomGrid';
import { ApproveRequestPageType } from './ApproveRequestDetailCase';

type PropType = {
  pageId?: any;
  approvalAppd: ApprovalAppd[];
  approvalInfr: ApprovalAppd[];
};

/**
 * 2025.10.06    sungim.kim2  [고도화] 병렬 결재 추가
 * 2025.10.31    jshwang12    셋업일정관련 요청인 경우 결재자 지정 불가, 통보자 미노출1
 * @param approvalAppd
 * @param approvalInfr
 * @constructor
 */
const ApproveDetailLineInfo = ({ pageId, approvalAppd, approvalInfr }: PropType) => {
  const { t } = useTranslation();
  const [rowDataAppd, setRowDataAppd] = useState<ApprovalAppd[]>(approvalAppd);
  const [rowDataInfr, setRowDataInfr] = useState<ApprovalAppd[]>(approvalInfr);
  const isSetupRequest = useMemo(
    () =>
      [ApproveRequestPageType.SETUP_SCHD_REG, ApproveRequestPageType.SETUP_SCHD_CHG].includes(
        pageId
      ),
    [pageId]
  );

  useEffect(() => {
    setRowDataAppd(approvalAppd);
    setRowDataInfr(approvalInfr);
  }, [approvalAppd, approvalInfr]);

  //[고도화] 병렬 결재 추가
  const layoutDefinitionAppd = [
    {
      binding: 'grnrAprTpDivsNm',
      header: `${t('com.grid.구분', '구분')}`,
      align: 'center',
      width: 100,
      // dataMap: new DataMap(aprTpDivsList || [], 'cmnCd', 'cmnCdNm'),
      visible: !isSetupRequest,
    },
    {
      binding: 'prlYn',
      header: `${t('com.grid.병렬', '병렬')}`,
      align: 'center',
      width: 60,
      visible: !isSetupRequest,
    },
    {
      binding: 'aprvUserNm',
      header: `${t('com.grid.성명', '성명')}`,
      align: 'center',
      width: 100,
    },

    {
      binding: 'aprvUserJikwiNm',
      header: `${t('com.grid.직책/직급호칭', '직책/직급호칭')}`,
      align: 'center',
      width: 150,
    },
    {
      binding: 'aprvUserDeptNm',
      header: `${t('com.grid.부서', '부서')}`,
      width: 200,
      align: 'left',
    },
    {
      binding: 'aprAprvDtm',
      header: `${t('com.grid.결재시간', '결재시간')}`,
      align: 'center',
      width: 180,
    },
    {
      binding: 'aprPsgStatNm',
      header: `${t('com.grid.결재결과', '결재결과')}`,
      align: 'center',
      width: 120,
    },
    {
      binding: 'aprAprvOpinUtf8Ctn',
      header: `${t('com.grid.결재의견', '결재의견')}`,
      align: 'left',
      width: '*',
    },
  ];

  const layoutDefinitionInfr = [
    {
      binding: 'grnrAprTpDivsCd',
      header: `${t('com.grid.구분', '구분')}`,
      align: 'center',
      width: 100,
      cellTemplate: (params) => {
        return `${t('com.label.통보', '통보')}`;
      },
    },
    {
      binding: 'aprvUserNm',
      header: `${t('com.grid.성명', '성명')}`,
      align: 'center',
      width: 200,
    },
    {
      binding: 'aprvUserJikwiNm',
      header: `${t('com.grid.직책/직급호칭', '직책/직급호칭')}`,
      align: 'center',
      width: 200,
    },
    {
      binding: 'aprvUserDeptNm',
      header: `${t('com.grid.부서', '부서')}`,
      width: '*',
      align: 'left',
    },
  ];

  return (
    <>
      <SubTitleLayout>
        <SubTitleGroup>
          <h3>{t('com.label.승인자 정보', '승인자 정보')}</h3>
        </SubTitleGroup>
      </SubTitleLayout>
      <CustomGrid
        id={'ApproveDetailLinInfoAppdGridId'}
        layoutDefinition={layoutDefinitionAppd}
        rowData={rowDataAppd}
        height={250}
        isReadOnly={true}
        isFilter={false}
        isSelector={false}
        allowPinning={false}
      />
      {!isSetupRequest && (
        <>
          <SubTitleLayout>
            <SubTitleGroup>
              <h3>{t('com.label.통보자 정보', '통보자 정보')}</h3>
            </SubTitleGroup>
          </SubTitleLayout>
          <CustomGrid
            id={'ApproveDetailLinInfoInfrGridId'}
            layoutDefinition={layoutDefinitionInfr}
            rowData={rowDataInfr}
            height={250}
            isReadOnly={true}
            isFilter={false}
            isSelector={false}
            allowPinning={false}
          />
        </>
      )}
    </>
  );
};
export default ApproveDetailLineInfo;
